enum MaterialPropertyTypes {
	NUMBER = "Number",
	SLIDER = "Slider",
	TEXTURE = "Texture",
	COLOR = "Color",
	TOGGLE = "Toggle",
	TEXT = "Text",
	TYPE = "Type",
	VIDEO = "Video",
	OPTIONS = "Options"
}

export default MaterialPropertyTypes;
